import React, { lazy } from 'react';
import { ArrowRightIcon, StarIcon } from 'lucide-react';
import { AudioPlayer } from './AudioPlayer';
export const HeroSection = () => {
  return <section className="py-8 md:py-10 relative overflow-hidden" data-id="element-196">
      {/* Christmas Background Effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-christmas-green/10 via-bttf-bg to-christmas-red/10" data-id="element-197"></div>
      <div className="absolute top-10 left-10 text-6xl opacity-20 animate-float" data-id="element-198">
        🎄
      </div>
      <div className="absolute top-20 right-20 text-5xl opacity-20 animate-float" style={{
      animationDelay: '1s'
    }} data-id="element-199">
        ⛄
      </div>
      <div className="absolute bottom-20 left-1/4 text-4xl opacity-20 animate-float" style={{
      animationDelay: '2s'
    }} data-id="element-200">
        🎁
      </div>

      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center relative z-10 gap-6 md:gap-8" data-id="element-201">
        <div className="md:w-1/2 mb-4 md:mb-0 md:pr-8 flex flex-col w-full md:justify-between md:min-h-[600px]" data-id="element-202">
          <div className="order-1" data-id="element-203">
            <div className="flex items-center gap-1.5 md:gap-4 mb-3 md:mb-6 flex-nowrap" data-id="element-204">
              <div className="inline-block bg-gradient-christmas text-white font-bold px-3 md:px-4 py-1.5 md:py-2 rounded-md shadow-christmas-glow animate-pulse whitespace-nowrap text-sm md:text-base border-2 border-christmas-gold/50" data-id="element-205">
                🎄 BEST SELLER
              </div>
              <div className="flex items-center gap-0.5 md:gap-2 flex-shrink-0 flex-nowrap" data-id="element-206">
                <div className="flex items-center gap-0.5" data-id="element-207">
                  <StarIcon className="h-4 w-4 md:h-6 md:w-6 text-christmas-gold fill-christmas-gold" data-id="element-208" />
                  <StarIcon className="h-4 w-4 md:h-6 md:w-6 text-christmas-gold fill-christmas-gold" data-id="element-209" />
                  <StarIcon className="h-4 w-4 md:h-6 md:w-6 text-christmas-gold fill-christmas-gold" data-id="element-210" />
                  <StarIcon className="h-4 w-4 md:h-6 md:w-6 text-christmas-gold fill-christmas-gold" data-id="element-211" />
                  <StarIcon className="h-4 w-4 md:h-6 md:w-6 text-christmas-gold fill-christmas-gold" data-id="element-212" />
                </div>
                <span className="text-base md:text-xl font-bold text-bttf-text" data-id="element-213">
                  5.0
                </span>
                <span className="text-xs md:text-lg text-bttf-subtext whitespace-nowrap" data-id="element-214">
                  (3,247+ Reviews)
                </span>
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-8 font-future tracking-tight bg-gradient-festive text-transparent bg-clip-text leading-tight" data-id="element-215">
              Back In Time: 40th Anniversary Collector's Edition
            </h1>
          </div>

          <div className="order-2 md:hidden flex justify-center mb-6" data-id="element-216">
            <div className="relative" data-id="element-217">
              {/* Christmas Wreath Effect */}
              <div className="absolute -inset-4 opacity-30" data-id="element-218">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 text-4xl" data-id="element-219">
                  🎀
                </div>
                <div className="absolute top-1/4 right-0 text-3xl animate-twinkle" data-id="element-220">
                  ⭐
                </div>
                <div className="absolute top-1/4 left-0 text-3xl animate-twinkle" style={{
                animationDelay: '1s'
              }} data-id="element-221">
                  ⭐
                </div>
              </div>
              <div className="absolute -inset-1 bg-gradient-festive rounded-lg blur-md opacity-75" data-id="element-222"></div>
              <div className="relative bg-bttf-bg rounded-lg overflow-hidden shadow-2xl transform rotate-0 hover:rotate-3 transition-transform duration-300 border-2 border-christmas-gold/50" data-id="element-223">
                <img src="https://cdn.magicpatterns.com/uploads/2cioQ989HPGJw23e6NPRQr/HEROSECTION.png" alt="Back In Time: 40th Anniversary Collector's Edition Book Cover" className="w-full h-auto object-cover" loading="lazy" data-id="element-224" />
              </div>
            </div>
          </div>

          <p className="text-xl mb-6 md:mb-10 text-bttf-subtext leading-relaxed order-3 md:order-2" data-id="element-225">
            <span className="text-christmas-gold font-bold" data-id="element-226">
              🎅 This Holiday Season:
            </span>{' '}
            The timeless story that redefined imagination and friendship.
            <br className="hidden md:block" data-id="element-227" />
            <span className="block mt-2" data-id="element-228">
              Celebrating 40 years of the film that made us believe in time
              again.
            </span>
          </p>

          <div className="order-4 md:order-3 bg-gradient-to-br from-bttf-bg via-christmas-green/10 to-christmas-red/10 border-2 border-christmas-gold/40 px-6 py-5 rounded-xl shadow-christmas-glow backdrop-blur-sm hover:shadow-[0_0_40px_rgba(255,215,0,0.6)] transition-all duration-300 mb-6 md:mb-10" data-id="element-229">
            <div className="flex items-center gap-3 mb-4" data-id="element-230">
              <span className="text-2xl" data-id="element-231">🎧</span>
              <span className="text-lg font-bold text-christmas-gold font-future tracking-wide" data-id="element-232">
                Preview the Book Here
              </span>
              <span className="text-xl animate-twinkle" data-id="element-233">✨</span>
            </div>
            <AudioPlayer src="https://cdn.shopify.com/s/files/1/0586/4069/5378/files/BIT_Audiobook_Preview.mp3?v=1762440014" data-id="element-234" />
          </div>

          <a href="#pricing" className="order-5 md:order-4 inline-flex items-center bg-gradient-christmas hover:opacity-90 text-white font-bold px-8 py-4 rounded-md text-lg transition-all transform hover:scale-105 shadow-md hover:shadow-christmas-glow w-fit border-2 border-christmas-gold/50" data-id="element-235">
            🎁 Get My Copy Now
            <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-236" />
          </a>
        </div>

        <div className="hidden md:flex md:w-1/2 justify-center md:justify-end" data-id="element-237">
          <div className="relative" data-id="element-238">
            {/* Christmas Wreath Effect */}
            <div className="absolute -inset-8 opacity-30" data-id="element-239">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 text-6xl" data-id="element-240">
                🎀
              </div>
              <div className="absolute top-1/4 right-0 text-4xl animate-twinkle" data-id="element-241">
                ⭐
              </div>
              <div className="absolute top-1/4 left-0 text-4xl animate-twinkle" style={{
              animationDelay: '1s'
            }} data-id="element-242">
                ⭐
              </div>
              <div className="absolute bottom-1/4 right-0 text-3xl animate-twinkle" style={{
              animationDelay: '2s'
            }} data-id="element-243">
                ❄️
              </div>
              <div className="absolute bottom-1/4 left-0 text-3xl animate-twinkle" style={{
              animationDelay: '1.5s'
            }} data-id="element-244">
                ❄️
              </div>
            </div>
            <div className="absolute -inset-1 bg-gradient-festive rounded-lg blur-md opacity-75" data-id="element-245"></div>
            <div className="relative bg-bttf-bg rounded-lg overflow-hidden shadow-2xl transform rotate-0 hover:rotate-3 transition-transform duration-300 border-2 border-christmas-gold/50" data-id="element-246">
              <img src="https://cdn.magicpatterns.com/uploads/2cioQ989HPGJw23e6NPRQr/HEROSECTION.png" alt="Back In Time: 40th Anniversary Collector's Edition Book Cover" className="w-full h-auto object-cover" loading="lazy" data-id="element-247" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};